export default "__VITE_ASSET__yYWW4Ug___"